import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Estimated Hours Saved',
      type: 'metric',
      content: {
        '{}': {
          name: 'Estimated Hours Saved',
          value: {
            '{}': {
              aside: 'hours',
              quality: {
                if: [
                  [
                    {
                      '>': [
                        {
                          '+': {
                            '@': 'hoursSavedValues',
                          },
                        },
                        0,
                      ],
                    },
                    'good',
                  ],
                  'neutral',
                ],
              },
              tooltip:
                'Estimated hours saved for the selected project or all projects.',
              emphasis: {
                'fmt.num': [
                  {
                    '+': {
                      '@': 'hoursSavedValues',
                    },
                  },
                  {
                    ',': true,
                    '.': {
                      max: 1,
                    },
                  },
                ],
              },
            },
          },
          description:
            'Total estimated productivity time saved through Cursor usage.',
        },
      },
    },
  },
  subqueries: {
    hoursSavedValues: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'projectId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!project',
                  {
                    ref: {
                      entity: '!proj',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'projectId',
                  },
                  'ent:!projects:!proj',
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!cursor_usage_events:!cursor_usage_event',
      selection: {
        '@.': '!est_hours_saved',
      },
    },
  },
}
